import React from 'react'
import { Text } from 'react-native'
import { generalStyles } from '../styles/general.styles.js'

const HeaderSubTitle = ({title}) => (
  <Text style={generalStyles.headerSubTitle}> {title || 'Título'} </Text>
)

export default HeaderSubTitle
